var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tasksIsEmpty)?_c('div',[_c('Subtitle',[_vm._v(" Você não possui nenhuma "+_vm._s(_vm.type)+". ")])],1):_c('div',_vm._l((_vm.tasks),function(task,i){return _c('TaskItem',{key:`task-item-${i}`,attrs:{"task":task}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }